import script from "./ZoomPanel.vue?vue&type=script&lang=ts&setup=true"
export * from "./ZoomPanel.vue?vue&type=script&lang=ts&setup=true"

import "./ZoomPanel.vue?vue&type=style&index=0&id=76954176&scoped=true&lang=css"

import exportComponent from "C:\\Users\\ga38som\\IdeaProjects\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-76954176"]])

export default __exports__